import { render, staticRenderFns } from "./AccountIvrCalls.vue?vue&type=template&id=cfa629ce&"
import script from "./AccountIvrCalls.vue?vue&type=script&lang=js&"
export * from "./AccountIvrCalls.vue?vue&type=script&lang=js&"
import style0 from "./AccountIvrCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports